module.exports = ":host {\n  z-index: 500; }\n"